import dayjs from "dayjs";

const RECENT_DAYS = 7;

/** Vrai si la date ISO (AAAA-MM-JJ) date de moins de 7 jours. */
export function isRecent(isoDate: string): boolean {
	const d = dayjs(isoDate);
	if (!isoDate || !d.isValid()) return false;
	const days = dayjs().diff(d, "day");
	return days >= 0 && days <= RECENT_DAYS;
}

/** Date ISO en français (ex : « 14 octobre 2026 »), ou "date inconnue". */
export function formatDay(isoDate: string): string {
	const d = dayjs(isoDate);
	return isoDate && d.isValid() ? d.format("D MMMM YYYY") : "date inconnue";
}
